import React from "react";
import { Box, Typography, Card } from "@mui/material";

const NotificationsSection = ({ notifications }) => {
  const has = notifications && notifications.length > 0;
  return (
    <Card
      sx={{
        p: has ? { xs: 2, sm: 3 } : 2, // Padding adjusts for different screen sizes
        borderRadius: 3,
        height: "100%",
        background: "#fffef7",
        boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
        border: "1px solid rgba(0,0,0,0.04)",
        width: "100%", // Ensure card takes full width on smaller screens
      }}
    >
      <Typography
        variant="h6"
        fontWeight={600}
        mb={2}
        sx={{
          fontSize: { xs: "1.2rem", sm: "1.5rem" }, // Adjust font size for small screens
        }}
      >
        Notifications
      </Typography>
      {!has ? (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            textAlign: "center",
            opacity: 0.7,
            fontSize: { xs: "0.8rem", sm: "1rem" }, // Adjust text size on smaller screens
          }}
        >
          No new notifications.
        </Typography>
      ) : (
        <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0 }}>
          {notifications.map((note) => (
            <Box key={note.id} component="li" mb={2}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontSize: { xs: "0.85rem", sm: "1rem" }, // Adjust text size
                }}
              >
                {note.message}
              </Typography>
              <Typography
                variant="caption"
                color="text.primary"
                sx={{
                  fontSize: { xs: "0.7rem", sm: "0.85rem" }, // Adjust caption size
                }}
              >
                {note.date}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Card>
  );
};

export default NotificationsSection;
